import type {X509Certificate} from 'node:crypto';
import { BadCredentialsError } from '../types.ts';

export type X509PrincipalExtractor = (cert: X509Certificate) => string;

/**
 * Extracts principal from X.509 certificate.
 * By default, extracts from certificate subject.
 * If principalAltName is 'email', extracts from email in Subject Alternative Name.
 */
export const subjectX500PrincipalExtractor: (opts?: {
    principalAltName?: 'email'
}) => X509PrincipalExtractor = (opts) => {
    const extractFromEmail = opts?.principalAltName === 'email';
    const subjectDnRegEx = /CN=(.*?)(?:,|$)/mi;
    return (cert: X509Certificate): string => {
        if (extractFromEmail) {
            const email = cert.subjectAltName?.split(', ').find((altName) => altName.startsWith('email:'));
            if (email) {
                return email.replace('email:', '');
            }
        }
        // Default: extract from subject
        const result = subjectDnRegEx.exec(cert.subject);
        if (result === null) {
            throw new BadCredentialsError(`Cannot extract principal from subject DN: ${cert.subject}`);
        }
        const username = result[1];
        return username;
    }
}
